export const goReportButtonStyles = {
    button: 'btn btn-default line small',
};
